import { render, staticRenderFns } from "./DispatchCorrespondence.vue?vue&type=template&id=dee6abde"
import script from "./DispatchCorrespondence.vue?vue&type=script&lang=js"
export * from "./DispatchCorrespondence.vue?vue&type=script&lang=js"
import style0 from "./DispatchCorrespondence.vue?vue&type=style&index=0&id=dee6abde&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports